let popupShown = false;
let inactivityTimer;

function showPopup() {
  const popup = document.getElementById('popupWhatsApp');
  if (!popupShown) {
    popup.classList.add('show');
    popupShown = true;

    setTimeout(() => {
      popup.classList.remove('show');
      popupShown = false;
    }, 15000);
  }
}

document.addEventListener('mouseleave', (e) => {
  if (!popupShown && window.innerWidth > 768 && e.clientY < 10) {
    showPopup();
  }
});

function resetInactivityTimer() {
  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(() => {
    if (!popupShown) showPopup();
  }, 30000);
}

['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(evt => {
  document.addEventListener(evt, resetInactivityTimer);
});

resetInactivityTimer();
document.addEventListener("DOMContentLoaded", function () {
  const waLink = document.getElementById("whatsapp-dynamic");

  if (waLink) {
    const phone = "5213332454402";
    const message = `¡Hola! Coriat Comercial, tengo una duda, me puedes ayudar con el siguiente producto: ${window.location.href}`;
    const encodedMessage = encodeURIComponent(message);

    const fullURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`;

    waLink.href = fullURL;
  }
});
